import { SButton, SIcon } from '@strana-artw/ui-kit';
import anime from 'animejs';
import { BODY_ID, BODY_INNER_ID, CLOSE_ID, OVERLAY_ID } from '@/shared/constants';
import { pageScrollService } from '@/shared/services';
var duration = 800;
var DRAWER_IDS = {
  OVERLAY: OVERLAY_ID,
  BODY: BODY_ID,
  BODY_INNER: BODY_INNER_ID,
  CLOSE: CLOSE_ID
};
export default {
  name: 'Drawer',
  components: {
    SIcon: SIcon,
    SButton: SButton
  },
  props: {
    preventScroll: {
      type: Boolean,
      default: false
    },
    fadeContent: {
      type: Boolean,
      default: true
    },
    layout: {
      type: String,
      default: null
    },
    disableDefaultPaddings: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup() {
    return {
      DRAWER_IDS: DRAWER_IDS,
      pageScrollLocked: false
    };
  },
  data: function data() {
    return {
      show: true
    };
  },
  computed: {
    isMobile: function isMobile() {
      return this.$breakpoint.mdAndDown;
    },
    bodyClasses: function bodyClasses() {
      if (this.layout) {
        return this.$style[this.layout];
      }
      return null;
    }
  },
  mounted: function mounted() {
    if (this.preventScroll) {
      var scrollableDrawerBody = document.getElementById(DRAWER_IDS.BODY);
      pageScrollService.lock([scrollableDrawerBody]);
      this.pageScrollLocked = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.pageScrollLocked) {
      var scrollableDrawerBody = document.getElementById(DRAWER_IDS.BODY);
      pageScrollService.unlock([scrollableDrawerBody]);
    }
  },
  methods: {
    handleCloseStart: function handleCloseStart() {
      this.$emit('closeStart');
      this.show = false;
    },
    handleClose: function handleClose() {
      this.$emit('closed');
    },
    enter: function enter() {
      var tl = anime.timeline({
        easing: 'easeOutExpo',
        duration: duration
      });
      tl.add({
        targets: "#".concat(DRAWER_IDS.OVERLAY),
        opacity: [0, 1],
        duration: duration,
        easing: 'easeOutCubic'
      }).add({
        targets: "#".concat(DRAWER_IDS.BODY),
        translateX: ['100%', 0],
        duration: duration,
        easing: 'easeOutCubic'
      }, 0).add({
        targets: "#".concat(DRAWER_IDS.CLOSE),
        opacity: [0, 1],
        duration: 300,
        easing: 'easeOutCubic'
      });
      if (this.fadeContent) {
        tl.add({
          targets: '#drawer-body-inner',
          opacity: [0, 1],
          duration: 400,
          easing: 'easeOutCubic'
        }, 400);
      }
    },
    leave: function leave(element, done) {
      var tl = anime.timeline({
        easing: 'easeOutExpo',
        duration: 1000,
        complete: done
      });
      tl.add({
        targets: "#".concat(DRAWER_IDS.CLOSE),
        opacity: [1, 0],
        duration: 300,
        easing: 'easeOutCubic'
      }).add({
        targets: "#".concat(DRAWER_IDS.BODY),
        translateX: [0, '100%'],
        duration: duration,
        easing: 'easeOutCubic',
        complete: done
      }, -0.3).add({
        targets: "#".concat(DRAWER_IDS.OVERLAY),
        opacity: [1, 0],
        duration: duration,
        easing: 'easeOutCubic'
      }, -0.1);

      // Показываем скролл в момент закрытия модалки
      // Это убирает эффект дерганья фиксированных элементов за модалкой
      var isDrawerBodyElement = element.id === DRAWER_IDS.BODY;
      if (isDrawerBodyElement && this.preventScroll && this.pageScrollLocked) {
        var scrollableDrawerBody = document.getElementById(DRAWER_IDS.BODY);
        pageScrollService.unlock([scrollableDrawerBody]);
        this.pageScrollLocked = false;
      }
    },
    afterLeave: function afterLeave() {
      this.$emit('closed');
    }
  }
};